var _style, _g, _g2, _g3, _defs, _polygon, _g4, _g5, _defs2, _polygon2, _defs3, _polygon3, _g6, _g7, _g8, _g9, _g10, _g11, _defs4, _path, _defs5, _rect, _g12, _g13, _g14, _defs6, _rect2, _g15, _g16, _g17, _g18, _g19, _g20, _defs7, _rect3, _g21, _g22, _g23, _defs8, _polygon4, _g24, _g25, _g26, _g27, _g28, _g29, _g30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBahamchistback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    viewBox: "111.7 251.07 372.75 340.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#263238;}\n\t.st1{fill:#FE4800;}\n\t.st2{opacity:0.5;clip-path:url(#SVGID_00000072998173731822749020000000552375638652852626_);enable-background:new    ;}\n\t.st3{opacity:0.7;clip-path:url(#SVGID_00000087383068447156662380000003364133771052824714_);enable-background:new    ;}\n\t.st4{fill:#FFDACC;}\n\t.st5{opacity:0.1;clip-path:url(#SVGID_00000037663096946672781980000013569486275436068739_);enable-background:new    ;}\n\t.st6{opacity:0.7;enable-background:new    ;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{opacity:0.2;enable-background:new    ;}\n\t.st9{fill:#92E3A9;}\n\t.st10{opacity:0.7;clip-path:url(#SVGID_00000041265667183484003010000001212647593189379759_);enable-background:new    ;}\n\t.st11{opacity:0.2;clip-path:url(#SVGID_00000127041342171493235940000002568864714650405287_);enable-background:new    ;}\n\t.st12{opacity:0.1;}\n\t.st13{opacity:0.1;enable-background:new    ;}\n\t.st14{opacity:0.5;clip-path:url(#SVGID_00000052802368282823101920000013866606342283815096_);enable-background:new    ;}\n\t.st15{opacity:0.3;clip-path:url(#SVGID_00000002386058274489284290000011795474864735786923_);enable-background:new    ;}\n\t.st16{opacity:0.7;clip-path:url(#SVGID_00000113355399396528822510000016667855082708720046_);enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.1,328.9h-22c-0.1,0-0.3-0.1-0.4-0.2s-0.1-0.2-0.1-0.4c0,0-0.2-2.7-8.2-7.2c-8.2-4.7-15,2.3-15.1,2.4     c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-9.9-16.7-26.2-16.7c0,0-0.1,0-0.1,0c-16.3,0.1-18.9,9.2-18.9,9.3     c-0.1,0.3-0.3,0.4-0.6,0.4c-0.3-0.1-0.4-0.3-0.4-0.6c0.1-0.4,2.8-10,19.9-10.1c15.3-0.1,25,13.7,26.9,16.6     c1.8-1.5,8.3-6.5,15.8-2.2c6.9,3.9,8.3,6.6,8.7,7.6h21.6c0.3,0,0.5,0.2,0.5,0.5S219.4,328.9,219.1,328.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.2,344.3h-17.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h17.7c2,0,4-0.9,5.4-2.4c1.6-1.7,4-3.5,7.1-5.3     c4.1-2.2,8.4-2.3,12.6-0.1c1.9,1.1,4.3,0.6,5.8-1.2c4-4.9,12.6-13.2,24.4-13.2c17.1,0.1,19.8,9.7,19.9,10.1     c0.1,0.3-0.1,0.5-0.4,0.6c-0.3,0.1-0.5-0.1-0.6-0.4c0-0.1-2.6-9.2-18.9-9.3c-11.4,0-19.7,8-23.6,12.8c-1.8,2.1-4.7,2.7-7,1.4     c-3.9-2-7.8-2-11.6,0.1c-3,1.7-5.3,3.4-6.9,5.1C413.7,343.3,411.4,344.3,409.2,344.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.3,333h-11.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H299c0.6-2.2,3.7-12.4,12.8-12.4c0.1,0,0.2,0,0.4,0     c7,0.2,9.8,4.1,10.8,6.7c1.8-6.6,8.9-8.9,11-9.4c-1.2-3.3-1.3-9,0.9-14c1.7-4,4.6-6.8,8.2-8.1c7.7-2.8,12.3-0.1,14,1.3     c0.8-4.2,5.1-21.1,24.5-23.7c20.1-2.8,28.4,18.5,29.7,22.4c2-1.1,8.9-4.2,15.6,3.2c2.1,2.2,3.5,4.6,4.3,7     c1.8,5.1,6.4,8.5,11.6,8.5h0.4c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-0.4c-5.6,0-10.7-3.7-12.6-9.1c-0.8-2.3-2.1-4.5-4.1-6.6     c-7.3-8.1-14.5-3-14.8-2.7c-0.1,0.1-0.3,0.1-0.5,0.1c-0.2-0.1-0.3-0.2-0.3-0.3c-0.1-0.3-7.6-25.3-28.9-22.3     c-21.3,2.9-23.7,23.6-23.8,23.8c0,0.2-0.2,0.4-0.3,0.4c-0.2,0.1-0.4,0-0.5-0.1c-0.2-0.2-4.6-4.9-13.7-1.7c-4.3,1.5-6.5,5-7.6,7.6     c-2.2,5.1-2,10.7-0.7,13.8c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-10.5,2.1-11.2,10.9c0,0.3-0.2,0.5-0.5,0.5     c0,0,0,0,0,0c-0.3,0-0.5-0.2-0.5-0.5c0-0.3-0.8-7.8-10.4-8c-9.7-0.3-12.3,11.9-12.3,12C299.8,332.8,299.6,333,299.3,333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,296c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5l51.8-2.6c2.9-0.2,5.5-1.8,6.9-4.3     c5.6-10.8,17.1-10.6,23.4-9.6c3,0.5,5.9-0.8,7.6-3.4c6.6-10.3,16.9-9.8,22.4-8.6c3.2,0.7,6.5-0.5,8.6-3c5.6-7,15.1-14.7,29-11.8     c12.5,2.6,19.2,10.1,22.6,15.9c2.7,4.5,7.5,7.4,12.9,7.6l4.5,0.2c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5l-4.5-0.2     c-5.7-0.2-10.8-3.2-13.7-8c-3.3-5.6-9.8-12.9-22-15.5c-13.4-2.8-22.6,4.7-28,11.4c-2.3,2.8-6,4.1-9.6,3.4     c-6.5-1.4-15.4-1.1-21.4,8.2c-1.9,2.9-5.2,4.4-8.6,3.8c-7.4-1.2-17.3-0.7-22.4,9c-1.6,2.8-4.5,4.7-7.7,4.9L164,296     C164.1,296,164.1,296,164,296z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Buildings"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.9,510.8c-0.3,0-0.5-0.2-0.5-0.5v-55.7c0-2.9,2.4-5.3,5.3-5.3h2c1.5,0,3-0.6,4.1-1.8l4.5-4.5     c1.1-1.1,1.8-2.7,1.8-4.2v-8c0-1,0.8-1.8,1.8-1.8c1.1,0,2,0.9,2,2v52.4c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V431     c0-0.5-0.5-1-1-1c-0.4,0-0.8,0.4-0.8,0.8v8c0,1.8-0.7,3.7-2,5l-4.5,4.5c-1.3,1.3-3,2-4.9,2h-2c-2.4,0-4.3,1.9-4.3,4.3v55.7     C136.4,510.6,136.1,510.8,135.9,510.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.4,545.7c-0.3,0-0.5-0.2-0.5-0.5v-52.1c0-2.8-2.3-5.1-5.1-5.1h-16.3c-3.4,0-6.1,2.7-6.1,6.1v25     c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-25c0-3.9,3.2-7.1,7.1-7.1h16.3c3.4,0,6.1,2.7,6.1,6.1v52.1     C176.9,545.5,176.6,545.7,176.4,545.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164,483.8c-0.3,0-0.5-0.2-0.5-0.5v-14.7c0-3.5,2.8-6.3,6.3-6.3h4c1.1,0,2-0.9,2-2v-12.5     c0-1.4,1.2-2.6,2.6-2.6c0.3,0,0.7-0.3,0.7-0.7v-25.1c0-1,0.8-1.8,1.8-1.8c1,0,1.8,0.8,1.8,1.8v17.9c0,0.7,0.6,1.3,1.3,1.3     c1.4,0,2.5,1.1,2.5,2.5v19.5c0,1.7,0.7,3.3,1.9,4.4l1.6,1.6c1,1,1.6,2.5,1.6,4v7.7c0,1.8,1.5,3.3,3.3,3.3h5.4     c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5H195c-2.4,0-4.3-1.9-4.3-4.3v-7.7c0-1.2-0.5-2.4-1.4-3.2l-1.6-1.6     c-1.4-1.4-2.1-3.2-2.1-5.2v-19.5c0-0.8-0.7-1.5-1.5-1.5c-1.3,0-2.3-1-2.3-2.3v-17.9c0-0.4-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v25.1     c0,1-0.9,1.7-1.7,1.7c-1,0-1.6,0.8-1.6,1.6v12.5c0,1.7-1.3,3-3,3h-4c-2.9,0-5.3,2.4-5.3,5.3v14.7     C164.5,483.6,164.3,483.8,164,483.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.8,549.4c-0.3,0-0.5-0.2-0.5-0.5v-34c0-2.4,1.9-4.3,4.3-4.3h0.9c1.5,0,2.8-1.3,2.8-2.8v-10.6     c0-2.7,2.1-4.8,4.8-4.8h2.4c1.9,0,3.4-1.5,3.4-3.4v-22.1c0-2.2,1.8-4,4-4h1.3c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.3     c-1.7,0-3,1.3-3,3V489c0,2.4-2,4.4-4.4,4.4H197c-2.1,0-3.8,1.7-3.8,3.8v10.6c0,2.1-1.7,3.8-3.8,3.8h-0.9c-1.8,0-3.3,1.5-3.3,3.3     v34C185.2,549.2,185,549.4,184.8,549.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.2,492.5c-0.3,0-0.5-0.2-0.5-0.5v-5.9c0-1.2-1-2.2-2.2-2.2h-1.1c-1.7,0-3-1.3-3-3v-13.2     c0-0.3-0.3-0.7-0.7-0.7h-0.3c-0.4,0-0.7,0.3-0.7,0.7V481c0,1.4-1.2,2.6-2.6,2.6h-5.8c-1,0-1.8,0.8-1.8,1.8v4.8     c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-4.8c0-1.6,1.2-2.8,2.8-2.8h5.8c0.8,0,1.6-0.6,1.6-1.6v-13.3c0-1,0.7-1.7,1.7-1.7h0.3     c1,0,1.7,0.9,1.7,1.7v13.2c0,1.1,0.9,2,2,2h1.1c1.8,0,3.2,1.4,3.2,3.2v5.9C420.7,492.3,420.4,492.5,420.2,492.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408,561.8c-0.3,0-0.5-0.2-0.5-0.5v-60.1c0-3.7,3-6.7,6.7-6.7h17.4c1.8,0,3.3-1.5,3.3-3.3v-18.6     c0-1.5-1.2-2.7-2.7-2.7c-0.3,0-0.5-0.2-0.5-0.5v-2.9c0-0.3,0.2-0.5,0.5-0.5c1.5,0,2.7-1.2,2.7-2.7v-9.8c0-1.9,1.6-3.5,3.5-3.5     c1.2,0,2.4,0.5,3.4,1.4l8.7,8.7c1.7,1.7,2.6,4,2.6,6.4v17.8c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-17.8c0-2.1-0.9-4.2-2.4-5.6     l-8.7-8.7c-0.7-0.7-1.7-1.2-2.6-1.2c-1.4,0-2.5,1.1-2.5,2.5v9.8c0,1.9-1.4,3.4-3.2,3.7v2c1.8,0.2,3.2,1.8,3.2,3.7v18.6     c0,2.4-1.9,4.3-4.3,4.3h-17.4c-3.1,0-5.7,2.6-5.7,5.7v60.1C408.5,561.6,408.3,561.8,408,561.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.2,539.4c-0.3,0-0.5-0.2-0.5-0.5V492c0-2.8,2.3-5.1,5.1-5.1H465c2.9,0,5.2,2.3,5.2,5.2v8.2     c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-8.2c0-2.3-1.9-4.2-4.2-4.2h-17.2c-2.2,0-4.1,1.9-4.1,4.1v46.9     C443.8,539.2,443.5,539.4,443.2,539.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.3,483.8c-0.3,0-0.5-0.2-0.5-0.5v-36.4c0-0.3-0.3-0.6-0.6-0.6H462c-0.3,0-0.7,0.3-0.7,0.7v36.3     c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V447c0-1,0.9-1.7,1.7-1.7h0.3c0.9,0,1.6,0.7,1.6,1.6v36.4     C463.8,483.6,463.6,483.8,463.3,483.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401,559.3c-0.3,0-0.5-0.2-0.5-0.5v-31.2c0-2.8-2.2-5-5-5h-21c-0.3,0-0.5-0.2-0.5-0.5v-47.7l-21.4-21.4     c-0.1-0.1-0.1-0.2-0.1-0.4v-21.9h-3.6v93.3c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-93.8c0-0.3,0.2-0.5,0.5-0.5h4.6     c0.3,0,0.5,0.2,0.5,0.5v22.2l21.4,21.4c0.1,0.1,0.1,0.2,0.1,0.4v47.4h20.5c3.3,0,6,2.7,6,6v31.2     C401.5,559.1,401.2,559.3,401,559.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.8,569.9c-0.3,0-0.5-0.2-0.5-0.5v-39.8h-27.7c-0.3,0-0.5-0.2-0.5-0.5v-27H324c-0.3,0-0.5-0.2-0.5-0.5     v-39.1h-2.8c-0.3,0-0.5-0.2-0.5-0.5v-37H316c-0.3,0-0.5-0.2-0.5-0.5v-44.7h-2.9v42.9c0,0.1-0.1,0.3-0.1,0.4l-5.1,5.2v21.5     c0,0.3-0.2,0.5-0.5,0.5h-9v51.3c0,0.3-0.2,0.5-0.5,0.5h-18.7v32.5c0,0.3-0.2,0.5-0.5,0.5H266v34.4c0,0.3-0.2,0.5-0.5,0.5     s-0.5-0.2-0.5-0.5v-34.9c0-0.3,0.2-0.5,0.5-0.5h12.2v-32.5c0-0.3,0.2-0.5,0.5-0.5H297v-51.3c0-0.3,0.2-0.5,0.5-0.5h9V428     c0-0.1,0.1-0.3,0.1-0.4l5.1-5.2v-43.2c0-0.3,0.2-0.5,0.5-0.5h3.9c0.3,0,0.5,0.2,0.5,0.5V424h4.1c0.3,0,0.5,0.2,0.5,0.5v37h2.8     c0.3,0,0.5,0.2,0.5,0.5v39.1h3.2c0.3,0,0.5,0.2,0.5,0.5v27h27.7c0.3,0,0.5,0.2,0.5,0.5v40.3C356.3,569.7,356.1,569.9,355.8,569.9     z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.9,548.2c-0.3,0-0.5-0.2-0.5-0.5v-29.1H226c-0.3,0-0.5-0.2-0.5-0.5v-35.6h-14.4c-0.3,0-0.5-0.2-0.5-0.5     s0.2-0.5,0.5-0.5H226c0.3,0,0.5,0.2,0.5,0.5v35.6h11.3c0.3,0,0.5,0.2,0.5,0.5v29.6C238.4,548,238.1,548.2,237.9,548.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.2,495.4c-0.3,0-0.5-0.2-0.5-0.5v-34.3h-44.4v33.6c0,0.3-0.2,0.5-0.5,0.5h-9.5c-0.3,0-0.5-0.2-0.5-0.5     s0.2-0.5,0.5-0.5h9v-33.6c0-0.3,0.2-0.5,0.5-0.5h45.4c0.3,0,0.5,0.2,0.5,0.5v34.8C283.8,495.2,283.5,495.4,283.2,495.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344,488h-16.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H344c0.3,0,0.5,0.2,0.5,0.5S344.3,488,344,488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.5,520.4c-0.3,0-0.5-0.2-0.5-0.5v-64.4c0-0.3,0.2-0.5,0.5-0.5h3.5c0.3,0,0.5,0.2,0.5,0.5v63.6     c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V456H384v63.9C384,520.2,383.7,520.4,383.5,520.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "383.5,314.4 383.5,345.4 380.4,345.4 380.4,319.2 361.5,319.2 361.5,345.4 358.2,345.4       358.2,319.2 251,319.2 251,345.4 247.9,345.4 247.9,319.2 228.9,319.2 228.9,345.4 225.8,345.4 225.8,314.4     "
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "383.5,314.4 383.5,345.4 380.4,345.4 380.4,319.2 361.5,319.2 361.5,345.4 358.2,345.4       358.2,319.2 251,319.2 251,345.4 247.9,345.4 247.9,319.2 228.9,319.2 228.9,345.4 225.8,345.4 225.8,314.4     "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137843071791405668360000016446824030473837960_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000137843071791405668360000016446824030473837960_)",
      enableBackground: "new"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "383.5,314.4 383.5,327.6 380.4,327.6 380.4,319.2 361.5,319.2 361.5,327.6 358.2,327.6 358.2,319.2 251,319.2       251,327.6 247.9,327.6 247.9,319.2 228.9,319.2 228.9,327.6 225.8,327.6 225.8,314.4     "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000057114627060725038230000016406211472937089967_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.5,345.9h-3.1c-0.3,0-0.5-0.2-0.5-0.5v-25.7H362v25.7c0,0.3-0.2,0.5-0.5,0.5h-3.2      c-0.3,0-0.5-0.2-0.5-0.5v-25.7H251.5v25.7c0,0.3-0.2,0.5-0.5,0.5H248c-0.3,0-0.5-0.2-0.5-0.5v-25.7h-18v25.7      c0,0.3-0.2,0.5-0.5,0.5h-3.1c-0.3,0-0.5-0.2-0.5-0.5v-31c0-0.3,0.2-0.5,0.5-0.5h157.6c0.3,0,0.5,0.2,0.5,0.5v31      C384,345.7,383.7,345.9,383.5,345.9z M380.8,344.9h2.1v-30H226.4v30h2.1v-25.7c0-0.3,0.2-0.5,0.5-0.5h19c0.3,0,0.5,0.2,0.5,0.5      v25.7h2.1v-25.7c0-0.3,0.2-0.5,0.5-0.5h107.2c0.3,0,0.5,0.2,0.5,0.5v25.7h2.2v-25.7c0-0.3,0.2-0.5,0.5-0.5h18.9      c0.3,0,0.5,0.2,0.5,0.5V344.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.9,307.6 335.1,307.6 314,307.6 230.2,307.6 208.1,321.2 292.9,321.2 326.1,321.2 401,321.2           "
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000057861288944554725180000013554102352116230553_",
    points: "378.9,307.6 335.1,307.6 314,307.6       230.2,307.6 208.1,321.2 292.9,321.2 326.1,321.2 401,321.2     "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054969961940461376440000000674423347488182666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057861288944554725180000013554102352116230553_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000054969961940461376440000000674423347488182666_)",
      enableBackground: "new"
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "378.9,307.6 335.1,307.6 314,307.6 230.2,307.6 208.1,321.2 292.9,321.2 326.1,321.2 401,321.2           "
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000183957994550024420360000001514853962821731752_",
    points: "378.9,307.6 335.1,307.6 314,307.6       230.2,307.6 208.1,321.2 292.9,321.2 326.1,321.2 401,321.2     "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148635007240276783580000011506024645643000759_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183957994550024420360000001514853962821731752_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      clipPath: "url(#SVGID_00000148635007240276783580000011506024645643000759_)",
      enableBackground: "new"
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "340.2,307.6 274.1,307.6 274.1,321.2 357.4,321.2     "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.2,310.7H261c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h114.3c0.3,0,0.5,0.2,0.5,0.5     S375.5,310.7,375.2,310.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,313.6H266c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h80.9c0.3,0,0.5,0.2,0.5,0.5     S347.1,313.6,346.8,313.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.8,316.9h-93.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h93.1c0.3,0,0.5,0.2,0.5,0.5     S340.1,316.9,339.8,316.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.3,313.6h-2.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.8c0.3,0,0.5,0.2,0.5,0.5     S353.6,313.6,353.3,313.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373,313.6h-10.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H373c0.3,0,0.5,0.2,0.5,0.5S373.2,313.6,373,313.6z     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382,310.7h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S382.3,310.7,382,310.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.2,316.9h-22.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h22.7c0.3,0,0.5,0.2,0.5,0.5     S368.4,316.9,368.2,316.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376,316.9h-3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S376.2,316.9,376,316.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.2,316.9h-9.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.8c0.3,0,0.5,0.2,0.5,0.5     S393.5,316.9,393.2,316.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.4,313.6h-21.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h21.1c0.3,0,0.5,0.2,0.5,0.5     S242.6,313.6,242.4,313.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.9,313.6H253c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.8c0.3,0,0.5,0.2,0.5,0.5     S256.1,313.6,255.9,313.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253,310.7h-21.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H253c0.3,0,0.5,0.2,0.5,0.5S253.3,310.7,253,310.7z     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231,316.9h-5.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.1c0.3,0,0.5,0.2,0.5,0.5S231.2,316.9,231,316.9z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.9,344.5v222.7c-26.6,14-59.2,22.2-98.3,23c-27,0.5-52.9-6.1-76.3-17.8V344.5H391.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.6,590.7c-25.1,0-49.9-6-73.6-17.9l-0.3-0.1V344h175.6v223.5l-0.3,0.1c-27.6,14.5-60.7,22.3-98.5,23.1    C292.6,590.7,291.6,590.7,290.6,590.7z M217.8,572.1c24.4,12.2,49.9,18.1,75.8,17.6c37.5-0.8,70.4-8.4,97.8-22.8V345H217.8V572.1z    "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M391.9,344.5v222.7c-26.6,14-59.2,22.2-98.3,23c-27,0.5-52.9-6.1-76.3-17.8V344.5H391.9z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333,
    y: 345.4,
    width: 7.7,
    height: 239.2
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "255,572.2 251,582.2 251,348.5 255,358.5    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "360.1,557.7 367.6,565.3 391.9,565.3 391.9,557.7 360.1,557.7     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "360.1,513.5 367.6,521.1 391.9,521.1 391.9,513.5 360.1,513.5     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "360.1,469.3 367.6,476.9 391.9,476.9 391.9,469.3 360.1,469.3     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "360.1,425.2 367.6,432.8 391.9,432.8 391.9,425.2 360.1,425.2     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "360.1,381 367.6,388.6 391.9,388.6 391.9,381 360.1,381     "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "217.1,557.7 224.6,565.3 250.8,565.3 250.8,557.7 217.1,557.7     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "217.1,513.5 224.6,521.1 250.8,521.1 250.8,513.5 217.1,513.5     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "217.1,469.3 224.6,476.9 250.8,476.9 250.8,469.3 217.1,469.3     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "217.1,425.2 224.6,432.8 250.8,432.8 250.8,425.2 217.1,425.2     "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "217.1,381 224.6,388.6 250.8,388.6 250.8,381 217.1,381     "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,335.2H219.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h169.8c0.3,0,0.5,0.2,0.5,0.5     S389.7,335.2,389.5,335.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,337.7H219.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h169.8c0.3,0,0.5,0.2,0.5,0.5     S389.7,337.7,389.5,337.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,340.2H219.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h169.8c0.3,0,0.5,0.2,0.5,0.5     S389.7,340.2,389.5,340.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,342.7H219.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h169.8c0.3,0,0.5,0.2,0.5,0.5     S389.7,342.7,389.5,342.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,345H219.6c-0.3,0-0.5-0.2-0.5-0.5v-8.7c0-2.2,1.7-3.9,3.9-3.9h163.6c1.8,0,3.3,1.5,3.3,3.3v9.3     C390,344.8,389.7,345,389.5,345z M220.1,344H389v-8.8c0-1.3-1-2.3-2.3-2.3H223c-1.6,0-2.9,1.3-2.9,2.9V344z"
  })))), /*#__PURE__*/React.createElement("g", null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M401.5,322.5H207.7c-1,0-1.7-0.8-1.7-1.7l0,0c0-0.9,0.7-1.5,1.5-1.5h193.9c0.9,0,1.6,0.7,1.6,1.6l0,0      C403,321.7,402.4,322.5,401.5,322.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054258256379485800210000004968883441365164478_",
    d: "M401.5,322.5H207.7c-1,0-1.7-0.8-1.7-1.7l0,0      c0-0.9,0.7-1.5,1.5-1.5h193.9c0.9,0,1.6,0.7,1.6,1.6l0,0C403,321.7,402.4,322.5,401.5,322.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136409229318990641000000010566104608700230065_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054258256379485800210000004968883441365164478_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000136409229318990641000000010566104608700230065_)",
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M401.5,322.5H207.6c-0.9,0-1.6-0.7-1.6-1.6l0,0c0-0.9,0.7-1.6,1.6-1.6h193.8c0.9,0,1.6,0.7,1.6,1.6l0,0      C403,321.7,402.4,322.5,401.5,322.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000114050567840082040690000004343604155177964217_",
    d: "M401.5,322.5H207.7c-1,0-1.7-0.8-1.7-1.7l0,0      c0-0.9,0.7-1.5,1.5-1.5h193.9c0.9,0,1.6,0.7,1.6,1.6l0,0C403,321.7,402.4,322.5,401.5,322.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049214029211685532290000008128463830345269921_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114050567840082040690000004343604155177964217_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      clipPath: "url(#SVGID_00000049214029211685532290000008128463830345269921_)",
      enableBackground: "new"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 319.2,
    width: 84.1,
    height: 3.3
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000162347284917519998860000011147271887811216559_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401.5,323H207.8c-1.2,0-2.2-1-2.2-2.2c0-1.1,0.9-2,2-2h193.9c1.2,0,2.1,0.9,2.1,2.1      C403.5,322,402.6,323,401.5,323z M207.5,319.8c-0.5,0-1,0.4-1,1c0,0.6,0.4,1.2,1.2,1.2h193.7c0.6,0,1.1-0.6,1.1-1.1      c0-0.6-0.5-1.1-1.1-1.1H207.5z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.2,572.9c-0.3,0-0.5-0.2-0.5-0.5V344.5c0-0.3,0.2-0.5,0.5-0.5h174.6c0.3,0,0.5,0.2,0.5,0.5v222.7    c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5V345H217.8v227.4C217.8,572.7,217.5,572.9,217.2,572.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    className: "st13"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "273.4,591.8 273.4,307.6 335.6,307.6 335.6,589.8     "
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000173142157876463291630000008916805624266901168_",
    points: "273.4,591.8 273.4,307.6 335.6,307.6       335.6,589.8     "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060714950451076248680000016194559032805494152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173142157876463291630000008916805624266901168_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000060714950451076248680000016194559032805494152_)",
      enableBackground: "new"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 273.4,
    y: 310.2,
    className: "st1",
    width: 62.3,
    height: 7.4
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.2,365.8H282c-2.2,0-4-1.8-4-4v-5.1c0-2.2,1.8-4,4-4h9.2c2.2,0,4,1.8,4,4v5.1      C295.2,363.9,293.4,365.8,291.2,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,366.3H282c-2.5,0-4.5-2-4.5-4.5v-5.1c0-2.5,2-4.5,4.5-4.5h9.2c2.5,0,4.5,2,4.5,4.5v5.1      C295.8,364.2,293.7,366.3,291.2,366.3z M282,353.2c-1.9,0-3.5,1.6-3.5,3.5v5.1c0,1.9,1.6,3.5,3.5,3.5h9.2c1.9,0,3.5-1.6,3.5-3.5      v-5.1c0-1.9-1.6-3.5-3.5-3.5H282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.6,377.8h-16.2c-2.9,0-5.2-2.3-5.2-5.2v-14.8c0-2.9,2.3-5.2,5.2-5.2h16.2c2.9,0,5.2,2.3,5.2,5.2v14.8       C246.8,375.5,244.5,377.8,241.6,377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.6,378.3h-16.2c-3.2,0-5.7-2.5-5.7-5.7v-14.8c0-3.2,2.5-5.7,5.7-5.7h16.2c3.2,0,5.7,2.5,5.7,5.7v14.8       C247.4,375.8,244.8,378.3,241.6,378.3z M225.5,353.1c-2.6,0-4.7,2.1-4.7,4.7v14.8c0,2.6,2.1,4.7,4.7,4.7h16.2       c2.6,0,4.7-2.1,4.7-4.7v-14.8c0-2.6-2.1-4.7-4.7-4.7H225.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,378.3c-0.3,0-0.5-0.2-0.5-0.5v-25.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.2       C229.5,378.1,229.2,378.3,229,378.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 377.8,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,381.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5v3.3      C249.5,381.4,249.2,381.6,249,381.6z M211.6,380.6h36.8v-2.3h-36.8V380.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,368.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,368.5,249,368.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,371h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5S249.2,371,249,371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,373.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,373.6,249,373.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,376.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,376.1,249,376.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,378.3h-37.9c-0.3,0-0.5-0.2-0.5-0.5v-9.2c0-1.9,1.5-3.4,3.4-3.4h35c0.3,0,0.5,0.2,0.5,0.5v12.1       C249.5,378.1,249.3,378.3,249,378.3z M211.6,377.3h36.9v-11.1H214c-1.3,0-2.4,1.1-2.4,2.4V377.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,365.8h1c1.3,0,2.4-1.1,2.4-2.4v-8.5c0-1.3-1.1-2.4-2.4-2.4h-1c-1.3,0-2.4,1.1-2.4,2.4v8.5     C259.4,364.7,260.4,365.8,261.6,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,366.3h-1c-1.5,0-2.8-1.3-2.9-2.9l0-8.5c0-1.6,1.3-2.9,2.9-2.9h1c1.6,0,2.9,1.3,2.9,2.9v8.5     C265.5,365,264.2,366.3,262.6,366.3z M261.6,353c-1,0-1.9,0.9-1.9,1.9v8.5c0.1,1,0.9,1.9,1.9,1.9h1c1,0,1.9-0.9,1.9-1.9v-8.5     c0-1-0.9-1.9-1.9-1.9H261.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.2,365.8h8.3c2.5,0,4.5-2,4.5-4.5v-4.2c0-2.5-2-4.5-4.5-4.5h-8.3c-2.5,0-4.5,2-4.5,4.5v4.2      C313.8,363.8,315.8,365.8,318.2,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.5,366.3h-8.3c-2.8,0-5-2.2-5-5v-4.2c0-2.8,2.2-5,5-5h8.3c2.8,0,5,2.2,5,5v4.2      C331.5,364.1,329.3,366.3,326.5,366.3z M318.2,353.1c-2.2,0-4,1.8-4,4v4.2c0,2.2,1.8,4,4,4h8.3c2.2,0,4-1.8,4-4v-4.2      c0-2.2-1.8-4-4-4H318.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.5,377.8h16.2c2.9,0,5.2-2.3,5.2-5.2v-14.8c0-2.9-2.3-5.2-5.2-5.2h-16.2c-2.9,0-5.2,2.3-5.2,5.2v14.8       C362.2,375.5,364.5,377.8,367.5,377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.7,378.3h-16.2c-3.2,0-5.7-2.5-5.7-5.7v-14.8c0-3.2,2.5-5.7,5.7-5.7h16.2c3.2,0,5.7,2.5,5.7,5.7v14.8       C389.3,375.8,386.8,378.3,383.7,378.3z M367.5,353.1c-2.6,0-4.7,2.1-4.7,4.7v14.8c0,2.6,2.1,4.7,4.7,4.7h16.2       c2.6,0,4.7-2.1,4.7-4.7v-14.8c0-2.6-2.1-4.7-4.7-4.7H367.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,378.3c-0.3,0-0.5-0.2-0.5-0.5v-25.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.2       C380.5,378.1,380.3,378.3,380,378.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.1,
    y: 377.9,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,381.7h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h37.8c0.3,0,0.5,0.2,0.5,0.5v3.3      C398.4,381.5,398.2,381.7,397.9,381.7z M360.6,380.7h36.8v-2.3h-36.8V380.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,368.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,368.5,398,368.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,371h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5S398.2,371,398,371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,373.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,373.6,398,373.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,376.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,376.1,398,376.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,378.3h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-12.1c0-0.3,0.2-0.5,0.5-0.5h35.3c1.7,0,3,1.3,3,3v9.6       C398.4,378.1,398.2,378.3,397.9,378.3z M360.6,377.3h36.8v-9.1c0-1.1-0.9-2-2-2h-34.8V377.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.9,365.8L346.9,365.8c-1.6,0-2.8-1.3-2.8-2.8v-7.5c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.5     C349.8,364.5,348.5,365.8,346.9,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,366.3c-1.8,0-3.3-1.5-3.3-3.3v-7.5c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v7.5     c0.1,0.8-0.2,1.6-0.8,2.2C348.7,365.9,347.8,366.3,346.8,366.3z M346.8,353.2c-1.3,0-2.3,1-2.3,2.3v7.5c0,1.3,1,2.3,2.3,2.3     c0.7,0,1.3-0.3,1.7-0.7c0.4-0.4,0.6-1,0.6-1.5l0-7.5C349.2,354.2,348.1,353.2,346.8,353.2z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.2,409.9H282c-2.2,0-4-1.8-4-4v-5.1c0-2.2,1.8-4,4-4h9.2c2.2,0,4,1.8,4,4v5.1      C295.2,408.1,293.4,409.9,291.2,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,410.4H282c-2.5,0-4.5-2-4.5-4.5v-5.1c0-2.5,2-4.5,4.5-4.5h9.2c2.5,0,4.5,2,4.5,4.5v5.1      C295.8,408.4,293.7,410.4,291.2,410.4z M282,397.3c-1.9,0-3.5,1.6-3.5,3.5v5.1c0,1.9,1.6,3.5,3.5,3.5h9.2c1.9,0,3.5-1.6,3.5-3.5      v-5.1c0-1.9-1.6-3.5-3.5-3.5H282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.5,422h-16c-2.9,0-5.3-2.4-5.3-5.3v-14.6c0-2.9,2.4-5.3,5.3-5.3h16c2.9,0,5.3,2.4,5.3,5.3v14.6       C246.8,419.6,244.4,422,241.5,422z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,422.5h-16c-3.2,0-5.8-2.6-5.8-5.8v-14.6c0-3.2,2.6-5.8,5.8-5.8h16c3.2,0,5.8,2.6,5.8,5.8v14.6       C247.4,419.9,244.7,422.5,241.5,422.5z M225.5,397.3c-2.6,0-4.8,2.2-4.8,4.8v14.6c0,2.6,2.2,4.8,4.8,4.8h16       c2.6,0,4.8-2.2,4.8-4.8v-14.6c0-2.6-2.2-4.8-4.8-4.8H225.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,422.5c-0.3,0-0.5-0.2-0.5-0.5v-25.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V422       C229.5,422.3,229.2,422.5,229,422.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 422,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,425.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5V422c0-0.3,0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5v3.3      C249.5,425.6,249.2,425.8,249,425.8z M211.6,424.8h36.8v-2.3h-36.8V424.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,412.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,412.6,249,412.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,415.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,415.2,249,415.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,417.7h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,417.7,249,417.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,420.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,420.2,249,420.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,422.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-9.8c0-1.6,1.2-2.8,2.8-2.8H249c0.3,0,0.5,0.2,0.5,0.5V422       C249.5,422.3,249.2,422.5,249,422.5z M211.6,421.5h36.8v-11.1h-35c-1,0-1.8,0.8-1.8,1.8V421.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,409.9h1c1.3,0,2.4-1.1,2.4-2.4V399c0-1.3-1.1-2.4-2.4-2.4h-1c-1.3,0-2.4,1.1-2.4,2.4v8.5     C259.4,408.8,260.4,409.9,261.6,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,410.4h-1c-1.5,0-2.8-1.3-2.9-2.9l0-8.5c0-1.6,1.3-2.9,2.9-2.9h1c1.6,0,2.9,1.3,2.9,2.9v8.5     C265.5,409.1,264.2,410.4,262.6,410.4z M261.6,397.1c-1,0-1.9,0.9-1.9,1.9v8.5c0.1,1,0.9,1.9,1.9,1.9h1c1,0,1.9-0.9,1.9-1.9V399     c0-1-0.9-1.9-1.9-1.9H261.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318,409.9h8.7c2.4,0,4.3-1.9,4.3-4.3V401c0-2.4-1.9-4.3-4.3-4.3H318c-2.4,0-4.3,1.9-4.3,4.3v4.6      C313.8,408,315.6,409.9,318,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.8,410.4H318c-2.7,0-4.8-2.1-4.8-4.8V401c0-2.7,2.1-4.8,4.8-4.8h8.7c2.7,0,4.8,2.1,4.8,4.8v4.6      C331.5,408.3,329.4,410.4,326.8,410.4z M318,397.2c-2.1,0-3.8,1.7-3.8,3.8v4.6c0,2.1,1.7,3.8,3.8,3.8h8.7c2.1,0,3.8-1.7,3.8-3.8      V401c0-2.1-1.7-3.8-3.8-3.8H318z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.5,422h16.2c2.9,0,5.2-2.3,5.2-5.2V402c0-2.9-2.3-5.2-5.2-5.2h-16.2c-2.9,0-5.2,2.3-5.2,5.2v14.8       C362.2,419.6,364.5,422,367.5,422z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.7,422.5h-16.2c-3.1,0-5.7-2.6-5.7-5.7V402c0-3.2,2.5-5.7,5.7-5.7h16.2c3.2,0,5.7,2.5,5.7,5.7v14.8       C389.3,420,386.8,422.5,383.7,422.5z M367.5,397.3c-2.6,0-4.7,2.1-4.7,4.7v14.8c0,2.6,2.1,4.7,4.7,4.7h16.2       c2.6,0,4.7-2.1,4.7-4.7V402c0-2.6-2.1-4.7-4.7-4.7H367.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,422.5c-0.3,0-0.5-0.2-0.5-0.5v-25.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V422       C380.5,422.3,380.3,422.5,380,422.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.1,
    y: 422,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,425.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5V422c0-0.3,0.2-0.5,0.5-0.5h37.8c0.3,0,0.5,0.2,0.5,0.5v3.3      C398.4,425.5,398.2,425.8,397.9,425.8z M360.6,424.8h36.8v-2.3h-36.8V424.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,412.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,412.6,398,412.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,415.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,415.2,398,415.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,417.7h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,417.7,398,417.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,420.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,420.2,398,420.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,422.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-12.1c0-0.3,0.2-0.5,0.5-0.5h35.2c1.7,0,3.1,1.4,3.1,3.1v9.5       C398.4,422.3,398.2,422.5,397.9,422.5z M360.6,421.5h36.8v-9c0-1.2-0.9-2.1-2.1-2.1h-34.7V421.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.9,409.9L346.9,409.9c-1.6,0-2.8-1.3-2.8-2.8v-7.5c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.5     C349.8,408.6,348.5,409.9,346.9,409.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,410.4c-1.8,0-3.3-1.5-3.3-3.3v-7.5c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v7.5     c0.1,0.8-0.2,1.6-0.8,2.2C348.7,410,347.8,410.4,346.8,410.4z M346.8,397.3c-1.3,0-2.3,1-2.3,2.3v7.5c0,1.3,1,2.3,2.3,2.3     c0.7,0,1.3-0.3,1.7-0.7c0.4-0.4,0.6-1,0.6-1.5l0-7.5C349.2,398.3,348.1,397.3,346.8,397.3z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.2,454H282c-2.2,0-4-1.8-4-4v-5.1c0-2.2,1.8-4,4-4h9.2c2.2,0,4,1.8,4,4v5.1      C295.2,452.2,293.4,454,291.2,454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,454.5H282c-2.5,0-4.5-2-4.5-4.5v-5.1c0-2.5,2-4.5,4.5-4.5h9.2c2.5,0,4.5,2,4.5,4.5v5.1      C295.8,452.5,293.7,454.5,291.2,454.5z M282,441.4c-1.9,0-3.5,1.6-3.5,3.5v5.1c0,1.9,1.6,3.5,3.5,3.5h9.2c1.9,0,3.5-1.6,3.5-3.5      v-5.1c0-1.9-1.6-3.5-3.5-3.5H282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.4,466.1h-16c-3,0-5.4-2.4-5.4-5.4v-14.5c0-3,2.4-5.4,5.4-5.4h16c3,0,5.4,2.4,5.4,5.4v14.5       C246.8,463.7,244.4,466.1,241.4,466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,466.6h-16c-3.3,0-5.9-2.6-5.9-5.9v-14.5c0-3.3,2.6-5.9,5.9-5.9h16c3.3,0,5.9,2.6,5.9,5.9v14.5       C247.4,464,244.7,466.6,241.5,466.6z M225.5,441.3c-2.7,0-4.9,2.2-4.9,4.9v14.5c0,2.7,2.2,4.9,4.9,4.9h16       c2.7,0,4.9-2.2,4.9-4.9v-14.5c0-2.7-2.2-4.9-4.9-4.9H225.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,466.6c-0.3,0-0.5-0.2-0.5-0.5v-25.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.2       C229.5,466.4,229.2,466.6,229,466.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 466.1,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,469.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5v3.3      C249.5,469.7,249.2,469.9,249,469.9z M211.6,468.9h36.8v-2.3h-36.8V468.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,456.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,456.8,249,456.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,459.3h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,459.3,249,459.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,461.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,461.8,249,461.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,464.4h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,464.4,249,464.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,466.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-9.6c0-1.7,1.3-3,3-3H249c0.3,0,0.5,0.2,0.5,0.5v12.1       C249.5,466.4,249.2,466.6,249,466.6z M211.6,465.6h36.8v-11.1h-34.8c-1.1,0-2,0.9-2,2V465.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,454h1c1.3,0,2.4-1.1,2.4-2.4v-8.5c0-1.3-1.1-2.4-2.4-2.4h-1c-1.3,0-2.4,1.1-2.4,2.4v8.5     C259.4,453,260.4,454,261.6,454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,454.5h-1c-1.6,0-2.8-1.2-2.9-2.9l0-8.5c0-1.6,1.3-2.9,2.9-2.9h1c1.6,0,2.9,1.3,2.9,2.9v8.5     C265.5,453.2,264.2,454.5,262.6,454.5z M261.6,441.2c-1,0-1.9,0.9-1.9,1.9v8.5c0.1,1.1,0.9,1.9,1.9,1.9h1c1,0,1.9-0.9,1.9-1.9     v-8.5c0-1-0.9-1.9-1.9-1.9H261.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.4,454h10.1c2,0,3.6-1.6,3.6-3.6v-6c0-2-1.6-3.6-3.6-3.6h-10.1c-2,0-3.6,1.6-3.6,3.6v6      C313.8,452.4,315.4,454,317.4,454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.5,454.5h-10.1c-2.3,0-4.1-1.8-4.1-4.1v-6c0-2.3,1.8-4.1,4.1-4.1h10.1c2.3,0,4.1,1.8,4.1,4.1v6      C331.5,452.7,329.7,454.5,327.5,454.5z M317.3,441.3c-1.7,0-3.1,1.4-3.1,3.1v6c0,1.7,1.4,3.1,3.1,3.1h10.1      c1.7,0,3.1-1.4,3.1-3.1v-6c0-1.7-1.4-3.1-3.1-3.1H317.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.9,466.1h15.4c3.1,0,5.6-2.5,5.6-5.6v-14c0-3.1-2.5-5.6-5.6-5.6h-15.4c-3.1,0-5.6,2.5-5.6,5.6v14       C362.2,463.6,364.8,466.1,367.9,466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.2,466.6h-15.4c-3.4,0-6.1-2.7-6.1-6.1v-14c0-3.4,2.7-6.1,6.1-6.1h15.4c3.4,0,6.1,2.7,6.1,6.1v14       C389.3,463.9,386.6,466.6,383.2,466.6z M367.8,441.4c-2.8,0-5.1,2.3-5.1,5.1v14c0,2.8,2.3,5.1,5.1,5.1h15.4       c2.8,0,5.1-2.3,5.1-5.1v-14c0-2.8-2.3-5.1-5.1-5.1H367.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,466.6c-0.3,0-0.5-0.2-0.5-0.5v-25.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.2       C380.5,466.4,380.3,466.6,380,466.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.1,
    y: 466.1,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,469.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h37.8c0.3,0,0.5,0.2,0.5,0.5v3.3      C398.4,469.7,398.2,469.9,397.9,469.9z M360.6,468.9h36.8v-2.3h-36.8V468.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,456.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,456.8,398,456.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,459.3h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,459.3,398,459.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,461.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,461.8,398,461.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,464.4h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,464.4,398,464.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,466.7h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-12.1c0-0.3,0.2-0.5,0.5-0.5h35.1c1.8,0,3.2,1.4,3.2,3.2v9.4       C398.4,466.4,398.2,466.7,397.9,466.7z M360.6,465.7h36.8v-8.9c0-1.2-1-2.2-2.2-2.2h-34.6V465.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.9,454L346.9,454c-1.6,0-2.8-1.3-2.8-2.8v-7.5c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.5     C349.8,452.8,348.5,454,346.9,454z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,454.5c-1.8,0-3.3-1.5-3.3-3.3v-7.5c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v7.5     c0.1,0.8-0.2,1.6-0.8,2.3C348.7,454.1,347.8,454.5,346.8,454.5z M346.8,441.4c-1.3,0-2.3,1-2.3,2.3v7.5c0,1.3,1,2.3,2.3,2.3     c0.7,0,1.3-0.3,1.8-0.7c0.4-0.4,0.6-1,0.5-1.5l0-7.5C349.2,442.4,348.1,441.4,346.8,441.4z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.2,498.2H282c-2.2,0-4-1.8-4-4v-5.1c0-2.2,1.8-4,4-4h9.2c2.2,0,4,1.8,4,4v5.1      C295.2,496.4,293.4,498.2,291.2,498.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,498.7H282c-2.5,0-4.5-2-4.5-4.5v-5.1c0-2.5,2-4.5,4.5-4.5h9.2c2.5,0,4.5,2,4.5,4.5v5.1      C295.8,496.7,293.7,498.7,291.2,498.7z M282,485.6c-1.9,0-3.5,1.6-3.5,3.5v5.1c0,1.9,1.6,3.5,3.5,3.5h9.2c1.9,0,3.5-1.6,3.5-3.5      v-5.1c0-1.9-1.6-3.5-3.5-3.5H282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.5,510.3h-16.1c-2.9,0-5.3-2.4-5.3-5.3v-14.7c0-2.9,2.4-5.3,5.3-5.3h16.1c2.9,0,5.3,2.4,5.3,5.3V505       C246.8,507.9,244.4,510.3,241.5,510.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.5,510.8h-16.1c-3.2,0-5.8-2.6-5.8-5.8v-14.7c0-3.2,2.6-5.8,5.8-5.8h16.1c3.2,0,5.8,2.6,5.8,5.8V505       C247.4,508.2,244.7,510.8,241.5,510.8z M225.5,485.5c-2.6,0-4.8,2.2-4.8,4.8V505c0,2.6,2.2,4.8,4.8,4.8h16.1       c2.6,0,4.8-2.2,4.8-4.8v-14.7c0-2.6-2.2-4.8-4.8-4.8H225.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,510.8c-0.3,0-0.5-0.2-0.5-0.5V485c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.3       C229.5,510.6,229.2,510.8,229,510.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 510.3,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,514.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5v3.3      C249.5,513.9,249.2,514.1,249,514.1z M211.6,513.1h36.8v-2.3h-36.8V513.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,500.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,500.9,249,500.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,503.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,503.5,249,503.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,506h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5S249.2,506,249,506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,508.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,508.5,249,508.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,510.8h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-9.7c0-1.6,1.3-2.9,2.9-2.9H249c0.3,0,0.5,0.2,0.5,0.5v12.1       C249.5,510.6,249.2,510.8,249,510.8z M211.6,509.8h36.8v-11.1h-34.9c-1,0-1.9,0.9-1.9,1.9V509.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,498.2h1c1.3,0,2.4-1.1,2.4-2.4v-8.5c0-1.3-1.1-2.4-2.4-2.4h-1c-1.3,0-2.4,1.1-2.4,2.4v8.5     C259.4,497.1,260.4,498.2,261.6,498.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,498.7h-1c-1.5,0-2.8-1.3-2.9-2.9l0-8.5c0-1.6,1.3-2.9,2.9-2.9h1c1.6,0,2.9,1.3,2.9,2.9v8.5     C265.5,497.4,264.2,498.7,262.6,498.7z M261.6,485.4c-1,0-1.9,0.9-1.9,1.9v8.5c0.1,1,0.9,1.9,1.9,1.9h1c1,0,1.9-0.9,1.9-1.9v-8.5     c0-1-0.9-1.9-1.9-1.9H261.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.1,498.2h10.6c1.9,0,3.4-1.5,3.4-3.4v-6.5c0-1.9-1.5-3.4-3.4-3.4h-10.6c-1.9,0-3.4,1.5-3.4,3.4v6.5      C313.8,496.7,315.2,498.2,317.1,498.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.8,498.7h-10.6c-2.2,0-3.9-1.7-3.9-3.9v-6.5c0-2.2,1.7-3.9,3.9-3.9h10.6c2.2,0,3.9,1.7,3.9,3.9v6.5      C331.7,497,329.9,498.7,327.8,498.7z M317.2,485.4c-1.6,0-2.9,1.3-2.9,2.9v6.5c0,1.6,1.3,2.9,2.9,2.9h10.6      c1.6,0,2.9-1.3,2.9-2.9v-6.5c0-1.6-1.3-2.9-2.9-2.9H317.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368,510.3h14.9c3.2,0,5.9-2.6,5.9-5.9v-13.5c0-3.2-2.6-5.9-5.9-5.9H368c-3.2,0-5.9,2.6-5.9,5.9v13.5       C362.2,507.6,364.9,510.3,368,510.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383,510.8H368c-3.4,0-6.3-2.9-6.4-6.4v-13.5c0-3.5,2.9-6.4,6.4-6.4H383c3.5,0,6.4,2.9,6.4,6.4v13.5       C389.3,507.9,386.5,510.8,383,510.8z M368,485.5c-3,0-5.4,2.4-5.4,5.4v13.5c0.1,3,2.5,5.4,5.4,5.4H383c3,0,5.4-2.4,5.4-5.4       v-13.5c0-3-2.4-5.4-5.4-5.4H368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,510.8c-0.3,0-0.5-0.2-0.5-0.5V485c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.3       C380.5,510.6,380.3,510.8,380,510.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.1,
    y: 510.2,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,514h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h37.8c0.3,0,0.5,0.2,0.5,0.5v3.3      C398.4,513.8,398.2,514,397.9,514z M360.6,513h36.8v-2.3h-36.8V513z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,500.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,500.9,398,500.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,503.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,503.5,398,503.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,506h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5S398.2,506,398,506z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,508.5h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,508.5,398,508.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,510.7h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-12.1c0-0.3,0.2-0.5,0.5-0.5h35c1.8,0,3.3,1.5,3.3,3.3v9.3       C398.4,510.5,398.2,510.7,397.9,510.7z M360.6,509.7h36.8V501c0-1.3-1.1-2.3-2.3-2.3h-34.5V509.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.9,498.2L346.9,498.2c-1.6,0-2.8-1.3-2.8-2.8v-7.5c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.5     C349.8,496.9,348.5,498.2,346.9,498.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,498.7c-1.8,0-3.3-1.5-3.3-3.3v-7.5c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v7.5     c0.1,0.8-0.2,1.6-0.8,2.2C348.7,498.3,347.8,498.7,346.8,498.7z M346.8,485.6c-1.3,0-2.3,1-2.3,2.3v7.5c0,1.3,1,2.3,2.3,2.3     c0.7,0,1.3-0.3,1.7-0.7c0.4-0.4,0.6-1,0.6-1.5l0-7.5C349.2,486.6,348.1,485.6,346.8,485.6z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.2,542.3H282c-2.2,0-4-1.8-4-4v-5.1c0-2.2,1.8-4,4-4h9.2c2.2,0,4,1.8,4,4v5.1      C295.2,540.5,293.4,542.3,291.2,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,542.8H282c-2.5,0-4.5-2-4.5-4.5v-5.1c0-2.5,2-4.5,4.5-4.5h9.2c2.5,0,4.5,2,4.5,4.5v5.1      C295.8,540.8,293.7,542.8,291.2,542.8z M282,529.7c-1.9,0-3.5,1.6-3.5,3.5v5.1c0,1.9,1.6,3.5,3.5,3.5h9.2c1.9,0,3.5-1.6,3.5-3.5      v-5.1c0-1.9-1.6-3.5-3.5-3.5H282z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.2,554.4h-15.5c-3.1,0-5.6-2.5-5.6-5.6v-14.1c0-3.1,2.5-5.6,5.6-5.6h15.5c3.1,0,5.6,2.5,5.6,5.6v14.1       C246.8,551.9,244.3,554.4,241.2,554.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.2,554.9h-15.5c-3.4,0-6.1-2.7-6.1-6.1v-14.1c0-3.4,2.7-6.1,6.1-6.1h15.5c3.4,0,6.1,2.7,6.1,6.1v14.1       C247.4,552.2,244.6,554.9,241.2,554.9z M225.8,529.6c-2.8,0-5.1,2.3-5.1,5.1v14.1c0,2.8,2.3,5.1,5.1,5.1h15.5       c2.8,0,5.1-2.3,5.1-5.1v-14.1c0-2.8-2.3-5.1-5.1-5.1H225.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,554.9c-0.3,0-0.5-0.2-0.5-0.5v-25.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.3       C229.5,554.7,229.2,554.9,229,554.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 554.4,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,558.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5v3.3      C249.5,558,249.2,558.2,249,558.2z M211.6,557.2h36.8v-2.3h-36.8V557.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,545.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,545.1,249,545.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,547.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,547.6,249,547.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,550.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,550.1,249,550.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,552.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H249c0.3,0,0.5,0.2,0.5,0.5       S249.2,552.6,249,552.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,554.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-9.7c0-1.6,1.3-2.9,2.9-2.9H249c0.3,0,0.5,0.2,0.5,0.5v12.1       C249.5,554.7,249.2,554.9,249,554.9z M211.6,553.9h36.8v-11.1h-34.9c-1,0-1.9,0.9-1.9,1.9V553.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M261.6,542.3h1c1.3,0,2.4-1.1,2.4-2.4v-8.5c0-1.3-1.1-2.4-2.4-2.4h-1c-1.3,0-2.4,1.1-2.4,2.4v8.5     C259.4,541.3,260.4,542.3,261.6,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,542.8h-1c-1.6,0-2.8-1.2-2.9-2.9l0-8.5c0-1.6,1.3-2.9,2.9-2.9h1c1.6,0,2.9,1.3,2.9,2.9v8.5     C265.5,541.5,264.2,542.8,262.6,542.8z M261.6,529.5c-1,0-1.9,0.9-1.9,1.9v8.5c0.1,1.1,0.9,1.9,1.9,1.9h1c1,0,1.9-0.9,1.9-1.9     v-8.5c0-1-0.9-1.9-1.9-1.9H261.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.8,542.3h9.3c2.2,0,4-1.8,4-4v-5.2c0-2.2-1.8-4-4-4h-9.3c-2.2,0-4,1.8-4,4v5.2      C313.8,540.5,315.5,542.3,317.8,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327,542.8h-9.3c-2.5,0-4.5-2-4.5-4.5v-5.2c0-2.5,2-4.5,4.5-4.5h9.3c2.5,0,4.5,2,4.5,4.5v5.2      C331.5,540.8,329.5,542.8,327,542.8z M317.8,529.6c-1.9,0-3.5,1.6-3.5,3.5v5.2c0,1.9,1.6,3.5,3.5,3.5h9.3c1.9,0,3.5-1.6,3.5-3.5      v-5.2c0-1.9-1.6-3.5-3.5-3.5H317.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.1,554.4H383c3.3,0,5.9-2.6,5.9-5.9V535c0-3.3-2.6-5.9-5.9-5.9h-14.9c-3.3,0-5.9,2.6-5.9,5.9v13.5       C362.2,551.8,364.9,554.4,368.1,554.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383,554.9h-14.9c-3.6,0-6.4-2.8-6.4-6.4V535c0-3.6,2.8-6.4,6.4-6.4H383c3.6,0,6.4,2.8,6.4,6.4v13.5       C389.5,552.1,386.6,554.9,383,554.9z M368.2,529.6c-3,0-5.4,2.4-5.4,5.4v13.5c0,3,2.4,5.4,5.4,5.4H383c3,0,5.4-2.4,5.4-5.4V535       c0-3-2.4-5.4-5.4-5.4H368.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,554.9c-0.3,0-0.5-0.2-0.5-0.5v-25.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v25.3       C380.5,554.7,380.3,554.9,380,554.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360.1,
    y: 554.4,
    className: "st1",
    width: 37.8,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,558.2h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-3.3c0-0.3,0.2-0.5,0.5-0.5h37.8c0.3,0,0.5,0.2,0.5,0.5v3.3      C398.4,558,398.2,558.2,397.9,558.2z M360.6,557.2h36.8v-2.3h-36.8V557.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,545.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,545.1,398,545.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,547.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,547.6,398,547.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,550.1h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,550.1,398,550.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398,552.6h-37.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H398c0.3,0,0.5,0.2,0.5,0.5       S398.2,552.6,398,552.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,554.9h-37.8c-0.3,0-0.5-0.2-0.5-0.5v-12.1c0-0.3,0.2-0.5,0.5-0.5h35.5c1.6,0,2.8,1.3,2.8,2.8v9.8       C398.4,554.7,398.2,554.9,397.9,554.9z M360.6,553.9h36.8v-9.3c0-1-0.8-1.8-1.8-1.8h-35V553.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M346.9,542.3L346.9,542.3c-1.6,0-2.8-1.3-2.8-2.8V532c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.5     C349.8,541,348.5,542.3,346.9,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,542.8c-1.8,0-3.3-1.5-3.3-3.3V532c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v7.5     c0.1,0.8-0.2,1.6-0.8,2.2C348.7,542.4,347.8,542.8,346.8,542.8z M346.8,529.7c-1.3,0-2.3,1-2.3,2.3v7.5c0,1.3,1,2.3,2.3,2.3     c0.7,0,1.3-0.3,1.7-0.7c0.4-0.4,0.6-1,0.6-1.5l0-7.5C349.2,530.7,348.1,529.7,346.8,529.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333.5,327.6h-57.7c-1.3,0-2.4-1.1-2.4-2.4v-8.4c0-1.3,1.1-2.4,2.4-2.4h57.8c1.1,0,2,0.9,2,2v8.9       C335.6,326.5,334.6,327.6,333.5,327.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000070814832523290369010000007538395414515801473_",
    d: "M333.5,327.6h-57.7c-1.3,0-2.4-1.1-2.4-2.4v-8.4       c0-1.3,1.1-2.4,2.4-2.4h57.8c1.1,0,2,0.9,2,2v8.9C335.6,326.5,334.6,327.6,333.5,327.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165222863058594298380000009119215323669653433_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070814832523290369010000007538395414515801473_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      clipPath: "url(#SVGID_00000165222863058594298380000009119215323669653433_)",
      enableBackground: "new"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273.4,
    y: 314.4,
    width: 62.3,
    height: 3.8
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000160870754563314590300000015728226469477841085_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.5,328.1h-57.7c-1.6,0-2.9-1.3-2.9-2.9v-8.4c0-1.6,1.3-2.9,2.9-2.9h57.8c1.4,0,2.5,1.1,2.5,2.5v8.9       c0.1,0.7-0.2,1.4-0.7,1.9C334.8,327.8,334.2,328.1,333.5,328.1z M275.8,314.9c-1,0-1.9,0.9-1.9,1.9v8.4c0,1,0.9,1.9,1.9,1.9       h57.7c0.4,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.8,0.4-1.2l0-8.9c0-0.8-0.7-1.5-1.5-1.5H275.8z"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.5,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C281,327.9,280.7,328.1,280.5,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.5,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C289,327.9,288.7,328.1,288.5,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.5,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C297,327.9,296.7,328.1,296.5,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.5,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C305,327.9,304.8,328.1,304.5,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.5,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C313,327.9,312.8,328.1,312.5,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M320.7,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C321.2,327.9,320.9,328.1,320.7,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.7,328.1c-0.3,0-0.5-0.2-0.5-0.5v-13.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v13.2      C329.2,327.9,328.9,328.1,328.7,328.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M343.5,308.6h-78l8.5-10.4c1.6-2,4-3.1,6.5-3.1h47.7c2.7,0,5.2,1.2,6.9,3.3L343.5,308.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062886614200047839770000007270910255132545427_",
    d: "M343.5,308.6h-78l8.5-10.4c1.6-2,4-3.1,6.5-3.1h47.7      c2.7,0,5.2,1.2,6.9,3.3L343.5,308.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062188750177204572330000004226809560075901618_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062886614200047839770000007270910255132545427_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000062188750177204572330000004226809560075901618_)",
      enableBackground: "new"
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "343.5,308.6 265.5,308.6 276.5,295.1 332.5,295.1     "
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000039113874310983903020000004804855701421697423_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.5,309.1h-78c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.1-0.4,0.1-0.5l8.5-10.4c1.7-2.1,4.2-3.3,6.9-3.3h47.7      c2.8,0,5.5,1.3,7.3,3.5l8.4,10.2c0.1,0.1,0.1,0.4,0.1,0.5S343.7,309.1,343.5,309.1z M266.6,308.1h75.9l-7.7-9.4      c-1.6-2-4-3.1-6.5-3.1h-47.7c-2.4,0-4.6,1.1-6.1,2.9L266.6,308.1z"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.4,
    y: 307,
    className: "st1",
    width: 80.1,
    height: 3.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000025426853366252940630000000063581118901305218_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.5,310.8h-80.1c-0.3,0-0.5-0.2-0.5-0.5V307c0-0.3,0.2-0.5,0.5-0.5h80.1c0.3,0,0.5,0.2,0.5,0.5v3.3      C345,310.6,344.8,310.8,344.5,310.8z M265,309.8H344v-2.3H265V309.8z"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 331.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.7,
    y: 334.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 347.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.1,
    y: 350.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.1,
    y: 371.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.3,
    y: 374.2,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.2,
    y: 377,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 380.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.9,
    y: 392.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.7,
    y: 371.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.4,450.7c-0.5,0-0.9,0-1.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 439.2,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.4,
    y: 436.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 421.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 418.2,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 399.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 396.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.8,
    y: 340.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.9,
    y: 337.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 389.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 399.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 422.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.8,
    y: 420,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.4,
    y: 545.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.4,
    y: 564.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 525.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.1,
    y: 523,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.2,
    y: 524.2,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 521.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.5,
    y: 504.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.9,
    y: 525.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.9,526c5.7-0.1,11.5-0.1,17,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.6,539c0.5,0,0.9,0,1.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.9,445.8c0.5,0,0.9,0,1.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.4,
    y: 455,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 457.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.5,
    y: 472.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 507,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.4,
    y: 490.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 493.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.7,
    y: 554.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.6,
    y: 557.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.4,
    y: 500.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 490.9,
    width: 5.8,
    height: 2.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.1,
    y: 546.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.9,
    y: 544.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.1,
    y: 549.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.2,
    y: 546.6,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.4,
    y: 514.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.6,
    y: 511.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 529.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 526.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.7,
    y: 558.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 514.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.4,447.8c-0.5,0-0.9,0-1.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 457,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.4,
    y: 459.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.8,
    y: 471.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.6,
    y: 475,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.6,
    y: 507,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 510,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.1,
    y: 482,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.1,
    y: 507,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.5,
    y: 473.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.8,
    y: 476.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.2,
    y: 340.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.4,
    y: 331.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 368.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.8,
    y: 371.8,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.5,
    y: 336.2,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.6,
    y: 339.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.5,
    y: 391.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.5,
    y: 368.9,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.6,359.5c0.5,0,0.9,0,1.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.3,
    y: 385.1,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 382.4,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 430.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 389.3,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 426.2,
    transform: "matrix(4.258073e-02 -0.9991 0.9991 4.258073e-02 -137.5559 714.6989)",
    width: 2.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.3,
    y: 423.5,
    transform: "matrix(4.256364e-02 -0.9991 0.9991 4.256364e-02 -131.6183 715.4004)",
    width: 2.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.6,
    y: 365.7,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.5,
    y: 362.5,
    width: 5.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.7,
    y: 409.2,
    transform: "matrix(4.258068e-02 -0.9991 0.9991 4.258068e-02 -120.7774 698.1001)",
    width: 2.3,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.5,
    y: 426.6,
    transform: "matrix(4.258073e-02 -0.9991 0.9991 4.258073e-02 -131.6439 721.5828)",
    width: 2.3,
    height: 5.8
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251,575.3c-0.3,0-0.5-0.2-0.5-0.5V348.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v226.3    C251.5,575.1,251.3,575.3,251,575.3z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.2,575.3c-0.3,0-0.5-0.2-0.5-0.5V348.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v226.3    C358.8,575.1,358.5,575.3,358.2,575.3z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.3,298.5H326c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.3c0.3,0,0.5,0.2,0.5,0.5     S329.6,298.5,329.3,298.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.2,298.4h-29.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h29.5c0.3,0,0.5,0.2,0.5,0.5     S317.5,298.4,317.2,298.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.5,298.5h-10.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10.2c0.3,0,0.5,0.2,0.5,0.5     S284.7,298.5,284.5,298.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.9,301.3H290c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.8c0.3,0,0.5,0.2,0.5,0.5     S295.1,301.3,294.9,301.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.5,301.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c4.7,0,9.4,0,14.1,0c4.8,0,9.5-0.1,14.3-0.1     c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5c-4.8,0-9.5,0-14.3,0.1C317.9,301.4,313.1,301.4,308.5,301.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.8,304.7h-2.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.3c0.3,0,0.5,0.2,0.5,0.5     S337.1,304.7,336.8,304.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.8,304.7h-19.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h19.5c0.3,0,0.5,0.2,0.5,0.5     S318.1,304.7,317.8,304.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.2,304.7H278c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h17.3c0.3,0,0.5,0.2,0.5,0.5     S295.5,304.7,295.2,304.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,304.7h-2.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.9c0.3,0,0.5,0.2,0.5,0.5S272.3,304.7,272,304.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.5,301.3H302c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.5c0.3,0,0.5,0.2,0.5,0.5     S303.8,301.3,303.5,301.3z"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Stars"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M212.4,396.1l-5.7-4.2c-0.8-0.6-1.9,0-1.9,1l0,0c0,0.7-0.5,1.2-1.2,1.2h-40.7c-3.4,0-6.2-2.8-6.2-6.2v-4.8     c0-0.7,0.5-1.2,1.2-1.2h27.7c5.3,0,9.6-4.3,9.6-9.6v-5.2c0-5.6-4.5-10.2-10.2-10.2h-64c-4.9,0-8.9,4-8.9,8.9v7.5     c0,4.8,3.9,8.7,8.7,8.7h28.7c0.7,0,1.2,0.5,1.2,1.2v6.3c0,5.9,4.8,10.7,10.7,10.7h42.2c0.7,0,1.2,0.5,1.2,1.2l0,0     c0,1,1.1,1.5,1.9,1l5.6-4.2C213,397.5,213,396.6,212.4,396.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.1,403.1c-0.3,0-0.6-0.1-0.8-0.2c-0.5-0.3-0.9-0.9-0.9-1.5c0-0.4-0.3-0.7-0.7-0.7h-42.2     c-6.2,0-11.2-5-11.2-11.2v-6.3c0-0.4-0.3-0.7-0.7-0.7h-28.7c-5.1,0-9.2-4.1-9.2-9.2v-7.5c0-5.2,4.2-9.4,9.4-9.4h64     c5.9,0,10.7,4.8,10.7,10.7v5.2c0,5.6-4.5,10.1-10.1,10.1H158c-0.4,0-0.7,0.3-0.7,0.7v4.8c0,3.1,2.6,5.7,5.7,5.7h40.7     c0.4,0,0.7-0.3,0.7-0.7c0-0.7,0.4-1.3,1-1.6c0.6-0.3,1.2-0.2,1.7,0.2l5.7,4.2c0,0,0,0,0,0c0.4,0.3,0.6,0.8,0.6,1.2     c0,0.6-0.2,1.1-0.7,1.6l-5.7,4.2C206.7,403,206.4,403.1,206.1,403.1z M121,357.4c-4.6,0-8.4,3.8-8.4,8.4v7.5     c0,4.5,3.7,8.2,8.2,8.2h28.7c1,0,1.7,0.7,1.7,1.7v6.3c0,5.6,4.6,10.2,10.2,10.2h42.2c1,0,1.7,0.7,1.7,1.7c0,0.4,0.2,0.5,0.3,0.6     c0.2,0.1,0.5,0.1,0.8,0l5.6-4.2c0.2-0.2,0.4-0.5,0.3-0.8c0-0.2-0.1-0.4-0.2-0.5l-5.7-4.2c-0.3-0.2-0.6-0.1-0.7-0.1     c-0.3,0.1-0.4,0.4-0.4,0.7c0,1-0.7,1.7-1.7,1.7H163c-3.7,0-6.7-3-6.7-6.7v-4.8c0-1,0.7-1.7,1.7-1.7h27.7c5,0,9.1-4.1,9.1-9.1     v-5.2c0-5.3-4.4-9.7-9.7-9.7H121z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "125.2,363.8 127,367.5 131,368.1 128.1,370.9 128.8,374.9 125.2,373 121.6,374.9 122.3,370.9       119.4,368.1 123.4,367.5     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.4,363.8 141.2,367.5 145.3,368.1 142.4,370.9 143,374.9 139.4,373 135.8,374.9 136.5,370.9       133.6,368.1 137.6,367.5     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "153.7,363.8 155.5,367.5 159.5,368.1 156.6,370.9 157.3,374.9 153.7,373 150.1,374.9 150.8,370.9       147.8,368.1 151.9,367.5     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "167.9,363.8 169.7,367.5 173.8,368.1 170.8,370.9 171.5,374.9 167.9,373 164.3,374.9 165,370.9       162.1,368.1 166.1,367.5     "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "182.2,363.8 184,367.5 188,368.1 185.1,370.9 185.8,374.9 182.2,373 178.6,374.9 179.2,370.9       176.3,368.1 180.4,367.5     "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahamchistback);
export default __webpack_public_path__ + "static/media/bahamchistback.5b1c22739f10a750b75b83bb326a812f.svg";
export { ForwardRef as ReactComponent };